// Opening an external link whose address the app does not know.
//
// src/data/*.js carries a link id; the URL lives behind /api/links and is only
// handed over after the server has checked the tier. Nothing here can be made
// to reveal an address the session is not entitled to.

/**
 * Resolves a link id and sends the browser there.
 *
 * The blank tab is opened *before* the await, on purpose. A window.open that
 * happens after a network round trip has lost its user-gesture and is blocked
 * as a popup, which on a phone looks exactly like a button that does nothing.
 * Opening first and setting location afterwards keeps the gesture.
 *
 * @returns "" on success, or a message to show the person.
 */
export async function openLink(id) {
  let tab = null;
  try {
    tab = window.open("", "_blank", "noopener");
  } catch {
    /* blocked anyway; fall back to navigating this tab below */
  }

  try {
    const r = await fetch("/api/links/" + encodeURIComponent(id));
    const d = await r.json().catch(() => ({}));

    if (!r.ok) {
      if (tab) tab.close();
      if (r.status === 404) return "That link hasn't been set up yet.";
      if (r.status === 403) return "That isn't available at your access level.";
      return d.error || "Could not open that link.";
    }

    if (tab) tab.location = d.url;
    else window.location.href = d.url;
    return "";
  } catch {
    if (tab) tab.close();
    return "Could not reach the server. Try again in a moment.";
  }
}
